(() => {
  if (window.__obVideos) return;
  window.__obVideos = true;

  let modal;
  let frame;

  const getModal = () => {
    if (modal) return modal;
    modal = document.createElement('dialog');
    modal.className = 'ob-video-modal';
    modal.setAttribute('aria-label', 'Video player');
    modal.innerHTML =
      '<button type="button" class="ob-video-modal__close" aria-label="Close video">&times;</button>' +
      '<div class="ob-video-modal__frame"></div>';
    frame = modal.querySelector('.ob-video-modal__frame');
    modal.querySelector('.ob-video-modal__close').addEventListener('click', () => modal.close());
    modal.addEventListener('click', (event) => {
      if (event.target === modal) modal.close();
    });
    modal.addEventListener('close', () => frame.replaceChildren());
    document.body.appendChild(modal);
    return modal;
  };

  const embedUrl = (provider, id, hash) => {
    if (provider === 'youtube') {
      return 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
    }
    if (provider === 'vimeo') {
      return (
        'https://player.vimeo.com/video/' +
        encodeURIComponent(id) +
        '?autoplay=1&dnt=1' +
        (hash ? '&h=' + encodeURIComponent(hash) : '')
      );
    }
    return '';
  };

  document.addEventListener('click', (event) => {
    const poster = event.target.closest('[data-ob-video-id]');
    if (!poster) return;
    const src = embedUrl(poster.dataset.obVideoProvider, poster.dataset.obVideoId, poster.dataset.obVideoHash);
    if (!src) return;
    const dialog = getModal();
    const iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.title = poster.getAttribute('aria-label') || 'Video';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen';
    iframe.allowFullscreen = true;
    frame.replaceChildren(iframe);
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  });

  const initGallery = (gallery) => {
    const buttons = Array.from(gallery.querySelectorAll('[data-ob-video-filter]'));
    const cards = Array.from(gallery.querySelectorAll('[data-ob-video-card]'));
    const count = gallery.querySelector('[data-ob-video-count]');
    const empty = gallery.querySelector('[data-ob-video-empty]');
    if (!buttons.length) return;

    const apply = (value, updateUrl) => {
      let shown = 0;
      cards.forEach((card) => {
        const match = !value || card.dataset.model === value;
        card.hidden = !match;
        if (match) shown += 1;
      });
      buttons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.obVideoFilter === value));
      });
      if (count) count.textContent = shown + (shown === 1 ? ' video' : ' videos');
      if (empty) empty.hidden = shown > 0;
      if (updateUrl) {
        const url = new URL(window.location.href);
        if (value) url.searchParams.set('model', value);
        else url.searchParams.delete('model');
        history.replaceState(history.state, '', url);
      }
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => apply(button.dataset.obVideoFilter, true));
    });

    const initial = new URL(window.location.href).searchParams.get('model') || '';
    const known = buttons.some((button) => button.dataset.obVideoFilter === initial);
    apply(known ? initial : '', false);
  };

  const init = () => document.querySelectorAll('[data-ob-video-gallery]').forEach(initGallery);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
